import { Center, Text } from '@mantine/core';
import { useNavigate } from 'react-router';

import { FlowStepWithContainer } from '../../../components/layout/FlowStepWithContainer.tsx';
import { Button } from '../../../components/ui/Button/Button.tsx';

export const Success = () => {
  const navigate = useNavigate();

  return (
    <FlowStepWithContainer
      bodyContent={
        <>
          <Text ta="center">You have successfully reset you password </Text>
          <Center mt={50}>
            <Button text="Login with your new password" type="button" onClick={() => void navigate('/auth/login')} />
          </Center>
        </>
      }
      heading="Reset password"
    />
  );
};
